module.exports = __webpack_public_path__ + "static/media/Logo_Merck_en.983512be.svg";